import { LocaleCode } from '@tink/config/src/markets';
import { applicationParameters } from '../../../../utilities/application-parameters';
import { ProviderField } from '../../../../models/provider';

const getGermanFieldMessages = () => {
  const isDe = applicationParameters.get('locale') === LocaleCode.DE;

  return {
    branch: isDe ? 'Filiale' : 'Branch',
    account: isDe ? 'Konto' : 'Account',
  };
};

export const getGermanBranchFieldDelta = (): Partial<ProviderField> => ({
  description: getGermanFieldMessages().branch,
  name: getGermanFieldMessages().branch,
  pattern: '(^[\\d]{3}$)',
  hint: '_ _ _',
  minLength: null,
  maxLength: null,
});

export const getGermanAccountFieldDelta = (): Partial<ProviderField> => ({
  description: getGermanFieldMessages().account,
  name: getGermanFieldMessages().account,
  pattern: '(^[\\d]{7}$)',
  hint: '_ _ _ _ _ _ _',
  minLength: null,
  maxLength: null,
});
